import React from "react";

import withStyles from "@material-ui/core/styles/withStyles";

import ChartSectionBordered from "../../../ChartSectionBordered/ChartSectionBordered";
import DashboardInfoTooltip from "../../../DasboardInfoTooltip";
import DetailsButton from "../../../DetailsButton";
import {MENUS} from "../../../../../OtherAssetV2/OtherAssetsModal/constants";
import AmountChip from "../../../AmountChip";
import {BadgeForNew} from "../../../../../../components/Badge";

import styles from "../../styles";


const AssetsCard = (props) => {
  const {
    classes,
    loading,
    error,
    total,
    openModal,
    expanded,
    onExpanded,
  } = props;

  return (
    <ChartSectionBordered
      title={
        <div>
          <div style={{display: 'flex', alignItems: 'center'}}>
            <b>Sonstige Vermögenwerte</b>
            <DashboardInfoTooltip
              title={
                'Übersicht über weitere Vermögenswerte Ihrer Kunden. Diese können – mit Ausnahme der Verrechnungskonten ' +
                'und Depots – manuell erfasst und bearbeitet werden. Die eingegebenen Werte bleiben unverändert. ' +
                'Verrechnungskonten und Depots bilden hierbei die Ausnahme, da deren aktualisierte Stände automatisch ' +
                'von den Depotstellen übermittelt werden.'
              }
            />
            <BadgeForNew />
          </div>
          <span className={classes.subHeader}>Sonstige Vermögenswerte inkl. Verrechnungskonten</span>
        </div>
      }
      titleControl={
        <DetailsButton
          dataId={'other-assets-details-btn'}
          onButtonClick={() => openModal(MENUS.assets.id)}
          tooltip={'Hier gelangen Sie zur Übersicht der Vermögenswerte und können neue hinzufügen sowie bestehende Vermögenswerte bearbeiten.'}
        />
      }
      expanded={expanded}
      onExpanded={onExpanded}
      loading={loading}
      error={error}
      displayError
      subSection
      fullHeight
      withSubHeader
      content={<AmountChip total={total} />}
    />
  )
};

export default withStyles(styles)(AssetsCard);